<template lang="pug">
  shListData(title="Designs History" resolver="designsHistory" keyData="_id" component="shDesign" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'DesignsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/design/DesignsHistory.vue